module.exports = __webpack_public_path__ + "static/media/nippon-express-logo.1dc62d27.png";